import { IconProps } from '@/components/Icon';

export const IconAvatar = ({ width = 24, height = 24, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 24 24' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z'
        fill='#E3FCF9'
      />
      <path
        clipRule='evenodd'
        d='M9.37546 8.5C9.37546 7.80381 9.65202 7.13613 10.1443 6.64384C10.6366 6.15156 11.3043 5.875 12.0005 5.875C12.6967 5.875 13.3643 6.15156 13.8566 6.64384C14.3489 7.13613 14.6255 7.80381 14.6255 8.5C14.6255 9.19619 14.3489 9.86387 13.8566 10.3562C13.3643 10.8484 12.6967 11.125 12.0005 11.125C11.3043 11.125 10.6366 10.8484 10.1443 10.3562C9.65202 9.86387 9.37546 9.19619 9.37546 8.5ZM7.18855 16.7279C7.20822 15.4647 7.72384 14.2599 8.62411 13.3735C9.52438 12.4871 10.7371 11.9903 12.0005 11.9903C13.2638 11.9903 14.4765 12.4871 15.3768 13.3735C16.2771 14.2599 16.7927 15.4647 16.8124 16.7279C16.8139 16.813 16.7906 16.8966 16.7453 16.9686C16.7 17.0406 16.6348 17.0978 16.5575 17.1333C15.1278 17.7888 13.5732 18.1271 12.0005 18.125C10.3753 18.125 8.83121 17.7703 7.44346 17.1333C7.36616 17.0978 7.30088 17.0406 7.25561 16.9686C7.21033 16.8966 7.18703 16.813 7.18855 16.7279Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
};
